import { useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';
import i18nMessages from './SideMenuTranslations';

const ItemBankManagementSideMenuBuilder = (accountId) => {
  const { formatMessage } = useIntl();
  const history = useHistory();

  const buildAddItemBankAssessmentContentTabs = () => {
    const addItemBankAssessmentContent = {
      label: formatMessage(i18nMessages.addItemBankAssessmentContent),
      icon: 'pi pi-plus',
      command: () => {
        const url = `/accounts/${accountId}/add-itembank-assessment-content`;
        history.push(url);
      },
    };

    return addItemBankAssessmentContent;
  };

  const buildAddItemBankSurveyContentTabs = () => {
    const addItemBankSurveyContent = {
      label: formatMessage(i18nMessages.addItemBankSurveyContent),
      icon: 'pi pi-plus',
      command: () => {
        const url = `/accounts/${accountId}/add-itembank-survey-content`;
        history.push(url);
      },
    };

    return addItemBankSurveyContent;
  };

  const buildUpdateTranslationsTabs = () => {
    const standardTranslations = {
      label: formatMessage(i18nMessages.standardTranslations),
      icon: 'pi pi-upload',
      command: () => {
        const url = `/accounts/${accountId}/update-itembank-translations`;
        history.push(url);
      },
    };

    const customAssessmentTranslations = {
      label: formatMessage(i18nMessages.assessmentCustomTranslations),
      icon: 'pi pi-upload',
      command: () => {
        const url = `/accounts/${accountId}/update-assessment-custom-translations`;
        history.push(url);
      },
    };

    const customSurveyTranslations = {
      label: formatMessage(i18nMessages.surveyCustomTranslations),
      icon: 'pi pi-upload',
      command: () => {
        const url = `/accounts/${accountId}/update-survey-custom-translations`;
        history.push(url);
      },
    };

    const customTranslations = {
      label: formatMessage(i18nMessages.customTranslations),
      icon: 'pi pi-upload',
      items: [
        customAssessmentTranslations,
        customSurveyTranslations,
      ],
    };

    const updateTranslations = {
      label: formatMessage(i18nMessages.updateTranslations),
      icon: 'pi pi-upload',
      items: [
        standardTranslations,
        customTranslations,
      ],
    };

    return updateTranslations;
  };

  const buildEnableContentTabs = () => {
    const enableAssessmentContent = {
      label: formatMessage(i18nMessages.enableContent),
      icon: 'pi pi-list',
      command: () => {
        const url = `/accounts/${accountId}/enable-content`;
        history.push(url);
      },
    };

    return enableAssessmentContent;
  };

  const buildItemBankManagementMenu = () => {
    const addItemBankAssessmentContent = buildAddItemBankAssessmentContentTabs();
    const addItemBankSurveyContent = buildAddItemBankSurveyContentTabs();
    const updateTranslations = buildUpdateTranslationsTabs();
    const enableContent = buildEnableContentTabs();

    const itemBankManagementItems = [updateTranslations,
      enableContent, addItemBankAssessmentContent, addItemBankSurveyContent];

    const itemBankManagement = {
      label: formatMessage(i18nMessages.itemBankManagement),
      icon: 'pi pi-cog',
      items: itemBankManagementItems,
    };

    return itemBankManagement;
  };

  return {
    buildItemBankManagementMenu,
  };
};

export default ItemBankManagementSideMenuBuilder;
